import adminAddComarchInvoiceHtml from './adminAddComarchInvoice.html';


class AdminAddComarchInvoiceController {
    constructor($scope, $http, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;

        this.loading = false;

        this.invoice = null;

        this.invoiceFile = null;
        this.invoiceNumber = null;
        this.invoiceIssueAt = new Date().toISOString().slice(0, 10);
        this.invoiceValueNet = null;
        this.invoiceValueGros = null;

        this.translate = translateService;
    }

    $onInit() {
        this.invoiceValueNet = this.valueNet;
        this.invoiceValueGros = this.valueGros;

        this.loading = true;

        this.$http.get('/admpanel/ajax/invoice/getAddedComarchInvoice/' + this.invoiceId, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'success') {
                    this.invoice = response.data.invoice;
                } else {
                    // alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    addInvoice() {
        this.editing = true;
    }

    validateFile() {
        if (!this.invoiceFile) {
            alert(this.translate.t('admpanel.invoices.invoiceFileNotSelected'));

            return;
        }

        if (this.invoiceFile && this.invoiceFile.fileSize > 10000240) {
            alert(this.translate.t('admpanel.invoices.maximumSizeOfUploadedFileIs', {extensions: '10'}));

            return;
        }

        return true;

    }

    saveInvoice() {
        this.loading = true

        if (!this.validateFile()) {
            this.loading = false;
            return;
        }

        const form = new FormData();

        let fileName = this.invoiceFile.fileName;

        form.append('order_id', this.orderId);
        form.append('number', this.invoiceNumber);
        form.append('issue_at', this.invoiceIssueAt);
        form.append('value_net', this.invoiceValueNet);
        form.append('value_gros', this.invoiceValueGros);
        form.append('file', this.invoiceFile.fileFormData.get('file'), fileName);

        this.invoiceFile = null;
        this.invoiceNumber = null;
        this.invoiceIssueAt = new Date().toISOString().slice(0, 10);
        this.invoiceValueNet = this.valueNet;
        this.invoiceValueGros = this.valueGros;

        this.$http.post('/admpanel/ajax/invoice/saveAddedComarchInvoice/', form, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        }).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'success') {
                    this.invoice = response.data.invoice;
                } else {
                    // alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    cancelInvoice() {
        this.editing = false;
    }

    deleteInvoice() {
        this.loading = true

        this.invoiceFile = null;
        this.invoiceNumber = null;
        this.invoiceIssueAt = new Date().toISOString().slice(0, 10);
        this.invoiceValueNet = this.valueNet;
        this.invoiceValueGros = this.valueGros;

        this.$http.get('/admpanel/ajax/invoice/deleteAddedComarchInvoice/' + this.invoiceId, {
            headers: {'Content-Type': 'application/json'}
        }).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'success') {
                    this.invoice = null;
                } else {
                    // alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }
}

let adminAddComarchInvoiceComponent = {
    bindings: {
        'orderId': '@',
        'invoiceId': '@',
        'valueNet': '@',
        'valueGros': '@',
        'currencyString': '@'
    },
    template: adminAddComarchInvoiceHtml,
    controller: AdminAddComarchInvoiceController
};

export default adminAddComarchInvoiceComponent;